import { combineReducers } from 'redux';
import { VEHICLES_FETCHED } from '../types';

const byId = (state = {}, action) => {
  switch (action.type) {
    case VEHICLES_FETCHED:
      return {
        ...state,
        ...action.payload.entities.vehicles
      };
    default:
      return state
  }
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case VEHICLES_FETCHED: {
      return action.payload.result
    }
    default:
      return state;
  }
};

const container = (state = [], action) => {
  switch (action.type) {
    case 'GET_VEHICLES':
      return action.payload.vehicles;
    default:
      return state
  }
};

export default combineReducers({ byId, allIds, container });



// WEBPACK FOOTER //
// ./src/reducers/vehiclesReducer.js